const LAST_CONVERSATION_KEY = 'assistant:lastConversationId';
const LAST_SEEN_KEY = 'assistant:lastConversationSeenAt';

/** How long a chat stays "current" after you look away from it (WEB-10278).
 *  Come back inside the window and the workspace / floating chat reopens that
 *  conversation; after it you land on a fresh chat and the "Continue
 *  conversation" link above the composer is the manual way back. */
export const RESUME_WINDOW_MS = 10 * 60 * 1000;

export const getLastConversationId = (): number | null => {
	try {
		const val = localStorage.getItem(LAST_CONVERSATION_KEY);
		return val ? Number(val) : null;
	} catch {
		return null;
	}
};

export const setLastConversationId = (id: number | null): void => {
	try {
		if (id) {
			localStorage.setItem(LAST_CONVERSATION_KEY, String(id));
			localStorage.setItem(LAST_SEEN_KEY, String(Date.now()));
		} else {
			localStorage.removeItem(LAST_CONVERSATION_KEY);
			localStorage.removeItem(LAST_SEEN_KEY);
		}
	} catch {
		/* localStorage unavailable */
	}
};

/** Restarts the resume window on the conversation that is already stored.
 *  Called while a chat is on screen (tab hidden, surface unmounted) so the
 *  window measures time since you last looked at it, not since you opened it. */
export const touchLastConversation = (): void => {
	try {
		if (!localStorage.getItem(LAST_CONVERSATION_KEY)) return;
		localStorage.setItem(LAST_SEEN_KEY, String(Date.now()));
	} catch {
		/* localStorage unavailable */
	}
};

/** The conversation to drop back into, or null to start a new chat. */
export const getResumableConversationId = (): number | null => {
	const id = getLastConversationId();
	if (!id) return null;
	try {
		const seenAt = Number(localStorage.getItem(LAST_SEEN_KEY));
		if (!seenAt || Date.now() - seenAt > RESUME_WINDOW_MS) return null;
	} catch {
		return null;
	}
	return id;
};
